export default __webpack_public_path__ + "3a050fb4ebe91f0bf232b459125705c4.png";